import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from '../lib/cn.js';
const TONE_CLASSES = {
    info: 'bg-info-surface border-info/30 text-content',
    success: 'bg-success-surface border-success/30 text-content',
    warning: 'bg-warning-surface border-warning/40 text-content',
    danger: 'bg-danger-surface border-danger/40 text-content',
};
export function Alert({ tone = 'info', title, children, className, requestId }) {
    const isUrgent = tone === 'danger' || tone === 'warning';
    return (_jsxs("div", { 
        // Errors interrupt; informational notices wait their turn.
        role: isUrgent ? 'alert' : 'status', className: cn('rounded-[var(--radius-surface)] border px-4 py-3 text-sm', TONE_CLASSES[tone], className), children: [title === undefined ? null : _jsx("p", { className: "mb-1 font-semibold", children: title }), _jsx("div", { className: "text-content-muted", children: children }), requestId === undefined ? null : (_jsxs("p", { className: "mt-2 font-mono text-xs text-content-subtle", children: ["Reference: ", requestId] }))] }));
}
//# sourceMappingURL=alert.js.map